import React, { useEffect } from 'react';

interface AboutModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const AboutModal: React.FC<AboutModalProps> = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      ></div>

      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[85vh] overflow-y-auto">
        {/* Header */}
        <div className="sticky top-0 bg-gradient-to-br from-[#0B1D3A] via-[#0F2847] to-[#0B1D3A] px-8 py-6 flex items-center justify-between border-b border-[#D4AF37]/20">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-[#D4AF37] to-[#C9A961] rounded-lg flex items-center justify-center">
              <i className="ri-information-line text-xl text-white"></i>
            </div>
            <h2 className="text-2xl font-bold text-white">Hakkımızda</h2>
          </div>
          <button
            onClick={onClose}
            className="w-10 h-10 flex items-center justify-center rounded-lg bg-white/10 hover:bg-white/20 text-white transition-all duration-300 cursor-pointer"
          >
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>

        {/* Content */}
        <div className="px-8 py-8">
          <div className="space-y-6 text-gray-700 leading-relaxed">
            <p className="text-lg font-semibold text-[#0B1D3A]">
              Prime Sales Pro, otellerin satış, kanal ve gelir teknolojilerini doğru şekilde konumlandırmalarını sağlayan yetkili satış ve ticari çözüm ortağıdır.
            </p>

            <p>
              Turizm sektöründe satış ve teknoloji, artık birbirinden ayrı değil; doğru teknoloji seçimi, doğru ticari sonuçların temelini oluşturur. Ancak birçok otel, ihtiyaçlarına en uygun sistemleri belirleme, bu sistemleri doğru şekilde konumlandırma ve ticari performansa dönüştürme süreçlerinde karmaşıklık yaşayabilmektedir.
            </p>

            <p>
              Prime Sales Pro, bu noktada oteller için güvenilir bir ticari çözüm ortağı olarak konumlanır.
            </p>

            <p>
              Sektörün önde gelen teknoloji platformlarının yetkili satış ve çözüm ortağı olarak, otellerin ihtiyaç duyduğu satış ve gelir yönetimi teknolojilerini doğrudan sunar ve teknoloji yatırımlarının doğru ticari sonuçlara dönüşmesini destekler.
            </p>

            <p>
              Prime Sales Pro'nun yaklaşımı, yalnızca bir teknoloji önermekten ibaret değildir. Her otelin ticari yapısı, satış kanalları ve büyüme hedefleri doğrultusunda en doğru çözüm belirlenir, teknoloji sağlayıcıları ile birlikte süreç yönetilir ve sistemlerin ticari performansa katkısı desteklenir.
            </p>

            <p>
              Teknik kurulum ve altyapı süreçleri ilgili teknoloji sağlayıcıları tarafından yürütülürken, Prime Sales Pro sürecin ticari tarafını yönetir, doğru konumlandırılmasını sağlar ve otelin teknoloji yatırımından maksimum fayda elde etmesine katkı sunar.
            </p>

            <p>
              Prime Sales Pro'nun temel amacı, otellerin teknoloji yatırımlarını daha bilinçli, daha verimli ve daha sürdürülebilir şekilde yönetmelerini sağlamaktır.
            </p>

            <p className="text-lg font-semibold text-[#0B1D3A]">
              Çünkü Prime Sales Pro'ya göre, başarılı sonuçlar tesadüf değildir; doğru kurgulanmış bir ticari yapı ve doğru teknoloji seçiminin doğal sonucudur.
            </p>
          </div>

          {/* Footer Button */}
          <div className="mt-8 pt-6 border-t border-gray-200">
            <button
              onClick={onClose}
              className="w-full px-6 py-3 bg-gradient-to-r from-[#D4AF37] to-[#C9A961] text-white rounded-lg font-semibold hover:shadow-lg hover:shadow-[#D4AF37]/30 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Kapat
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutModal;
